var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOuterBorderActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 4,
    fill: "#326FAE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2584 8.74023V27.2545H8.74414V8.74023H27.2584Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.30957 8.30664H9.66921V9.1745H9.17743V9.66628H8.30957V8.30664ZM10.9035 8.30664H12.7549V9.1745H10.9035V8.30664ZM13.9892 8.30664H15.8406V9.1745H13.9892V8.30664ZM17.0749 8.30664H18.9264V9.1745H17.0749V8.30664ZM20.1606 8.30664H22.0121V9.1745H20.1606V8.30664ZM23.2464 8.30664H25.0978V9.1745H23.2464V8.30664ZM26.3321 8.30664H27.6917V9.66628H26.8239V9.1745H26.3321V8.30664ZM27.6917 10.9006V12.752H26.8239V10.9006H27.6917ZM8.30957 12.752V10.9006H9.17743V12.752H8.30957ZM27.6917 13.9863V15.8377H26.8239V13.9863H27.6917ZM8.30957 15.8377V13.9863H9.17743V15.8377H8.30957ZM8.30957 18.9234V17.072H9.17743V18.9234H8.30957ZM27.6917 17.072V18.9234H26.8239V17.072H27.6917ZM8.30957 22.0091V20.1577H9.17743V22.0091H8.30957ZM27.6917 20.1577V22.0091H26.8239V20.1577H27.6917ZM27.6917 23.2434V25.0949H26.8239V23.2434H27.6917ZM8.30957 25.0949V23.2434H9.17743V25.0949H8.30957ZM27.6917 26.3291V27.6888H26.3321V26.8209H26.8239V26.3291H27.6917ZM8.30957 26.3291H9.17743V26.8209H9.66921V27.6888H8.30957V26.3291ZM12.7549 27.6888H10.9035V26.8209H12.7549V27.6888ZM15.8406 27.6888H13.9892V26.8209H15.8406V27.6888ZM18.9264 27.6888H17.0749V26.8209H18.9264V27.6888ZM22.0121 27.6888H20.1606V26.8209H22.0121V27.6888ZM25.0978 27.6888H23.2464V26.8209H25.0978V27.6888Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2577 7.58301C27.8969 7.58301 28.4149 8.10102 28.4149 8.74015C28.4149 9.37928 27.8969 9.89729 27.2577 9.89729C26.6186 9.89729 26.1006 9.37928 26.1006 8.74015C26.1006 8.10102 26.6186 7.58301 27.2577 7.58301Z",
    fill: "#326FAE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2581 8.01727C26.8586 8.01727 26.5348 8.34101 26.5348 8.74049C26.5348 9.13996 26.8586 9.4637 27.2581 9.4637C27.6575 9.4637 27.9813 9.13996 27.9813 8.74049C27.9813 8.34101 27.6575 8.01727 27.2581 8.01727ZM25.667 8.74049C25.667 7.8617 26.3793 7.14941 27.2581 7.14941C28.1368 7.14941 28.8491 7.8617 28.8491 8.74049C28.8491 9.61927 28.1368 10.3316 27.2581 10.3316C26.3793 10.3316 25.667 9.61927 25.667 8.74049Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.74308 7.58301C9.38221 7.58301 9.90022 8.10102 9.90022 8.74015C9.90022 9.37928 9.38221 9.89729 8.74308 9.89729C8.10395 9.89729 7.58594 9.37928 7.58594 8.74015C7.58594 8.10102 8.10395 7.58301 8.74308 7.58301Z",
    fill: "#326FAE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.74342 8.01727C8.34394 8.01727 8.0202 8.34101 8.0202 8.74049C8.0202 9.13996 8.34394 9.4637 8.74342 9.4637C9.14289 9.4637 9.46663 9.13996 9.46663 8.74049C9.46663 8.34101 9.14289 8.01727 8.74342 8.01727ZM7.15234 8.74049C7.15234 7.86171 7.86463 7.14941 8.74342 7.14941C9.6222 7.14941 10.3345 7.86171 10.3345 8.74049C10.3345 9.61927 9.6222 10.3316 8.74342 10.3316C7.86463 10.3316 7.15234 9.61927 7.15234 8.74049Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.74308 26.0977C9.38221 26.0977 9.90022 26.6157 9.90022 27.2548C9.90022 27.8939 9.38221 28.4119 8.74308 28.4119C8.10395 28.4119 7.58594 27.8939 7.58594 27.2548C7.58594 26.6157 8.10395 26.0977 8.74308 26.0977Z",
    fill: "#326FAE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.74342 26.5319C8.34394 26.5319 8.0202 26.8557 8.0202 27.2551C8.0202 27.6546 8.34394 27.9783 8.74342 27.9783C9.14289 27.9783 9.46663 27.6546 9.46663 27.2551C9.46663 26.8557 9.14289 26.5319 8.74342 26.5319ZM7.15234 27.2551C7.15234 26.3764 7.86463 25.6641 8.74342 25.6641C9.6222 25.6641 10.3345 26.3764 10.3345 27.2551C10.3345 28.1339 9.6222 28.8462 8.74342 28.8462C7.86463 28.8462 7.15234 28.1339 7.15234 27.2551Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2577 26.0977C27.8969 26.0977 28.4149 26.6157 28.4149 27.2548C28.4149 27.8939 27.8969 28.4119 27.2577 28.4119C26.6186 28.4119 26.1006 27.8939 26.1006 27.2548C26.1006 26.6157 26.6186 26.0977 27.2577 26.0977Z",
    fill: "#326FAE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2581 26.5319C26.8586 26.5319 26.5348 26.8557 26.5348 27.2551C26.5348 27.6546 26.8586 27.9783 27.2581 27.9783C27.6575 27.9783 27.9813 27.6546 27.9813 27.2551C27.9813 26.8557 27.6575 26.5319 27.2581 26.5319ZM25.667 27.2551C25.667 26.3764 26.3793 25.6641 27.2581 25.6641C28.1368 25.6641 28.8491 26.3764 28.8491 27.2551C28.8491 28.1339 28.1368 28.8462 27.2581 28.8462C26.3793 28.8462 25.667 28.1339 25.667 27.2551Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOuterBorderActive);
export default __webpack_public_path__ + "static/media/outer-border-active.146b0aabf263e8b8780dea6dfce92d7c.svg";
export { ForwardRef as ReactComponent };